/* Cards Game Night — cart page (AJAX qty / remove / add, section re-render) */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function swap(sectionId, html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cgn-cart]');
    var wrap = document.getElementById('shopify-section-' + sectionId);
    if (!fresh || !wrap) { window.location.reload(); return; }
    fresh.classList.add('is-refresh');
    var old = wrap.querySelector('[data-cgn-cart]');
    old.replaceWith(fresh);
    init(fresh);
  }
  function bubble(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inner = doc.querySelector('.shopify-section');
    var el = document.getElementById('cart-icon-bubble');
    if (inner && el) el.innerHTML = inner.innerHTML;
  }
  function post(url, body, box) {
    box.classList.add('is-busy');
    body.sections = [box.dataset.section, 'cart-icon-bubble'].join(',');
    body.sections_url = window.location.pathname;
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      box.classList.remove('is-busy');
      if (res.status && res.description) { alertMsg(box, res.description); return; }
      if (res.sections) { bubble(res.sections['cart-icon-bubble']); swap(box.dataset.section, res.sections[box.dataset.section]); }
      else window.location.reload();
    }).catch(function () { window.location.reload(); });
  }
  function alertMsg(box, msg) {
    var p = document.createElement('p');
    p.className = 'cgn-cart__err';
    p.style.cssText = 'color:#c11;font-weight:700;margin:0 0 16px';
    p.textContent = msg;
    box.querySelector('.cgn-wrap').prepend(p);
    setTimeout(function () { p.remove(); }, 5000);
  }

  function init(box) {
    if (box.dataset.ready) return;
    box.dataset.ready = '1';
    var timer;

    box.querySelectorAll('.cgn-line').forEach(function (line) {
      var input = line.querySelector('[data-qty-val]');
      var lineNo = parseInt(line.dataset.line, 10);
      function commit(q) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (q <= 0) line.classList.add('is-removing');
          setTimeout(function () { post('cart/change.js', { line: lineNo, quantity: Math.max(0, q) }, box); }, q <= 0 ? 350 : 0);
        }, 350);
      }
      line.querySelectorAll('[data-qty-change]').forEach(function (b) {
        b.addEventListener('click', function () {
          var q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qtyChange, 10));
          input.value = q;
          commit(q);
        });
      });
      input.addEventListener('change', function () { commit(parseInt(input.value, 10) || 0); });
      var rm = line.querySelector('[data-remove]');
      if (rm) rm.addEventListener('click', function () { input.value = 0; commit(0); });
    });

    var sticky = box.querySelector('.cgn-cart__sticky'), realBtn = box.querySelector('.cgn-sum__checkout');
    if (sticky && realBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-hidden', en[0].isIntersecting); }).observe(realBtn);
    }

    box.querySelectorAll('[data-cart-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('is-loading')) return;
        b.classList.add('is-loading');
        b.textContent = 'Adding…';
        post('cart/add.js', { items: [{ id: parseInt(b.dataset.cartAdd, 10), quantity: 1 }] }, box);
      });
    });
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-cgn-cart]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
